import React from 'react'

export default props => (
    <div className='row'>
		<div className='col col-md-12' style={props.style}>
			{props.children}
		</div>
	</div>
)
